import { useCallback } from 'react';
import { Divider } from 'antd';
import dayjs from 'dayjs';
import OrderStateComp from '@/components/order-state';
import ScoreStar from '../ScoreStar';
import cx from './index.module.scss';

export const handleServiceDuration = (seconds?: number) => {
  if (!seconds) return '-';

  if (seconds < 60) {
    return seconds.toString().padStart(2, '0') + '秒';
  } else {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return minutes + '分钟' + remainingSeconds.toString().padStart(2, '0') + '秒';
  }
};

const ServiceRecordCard = ({ record }: { record: ServiceRecordItem }) => {
  const serviceTime = useCallback((timestamp: number) => {
    if (!timestamp) return '-';

    return dayjs(timestamp).format('YYYY-MM-DD HH:mm:ss');
  }, []);

  return (
    <div className={cx('container')}>
      <div className={cx('header')}>
        <div className={cx('title')}>{record.goodsName}</div>
        <div className={cx('tag')}>
          <OrderStateComp state={record.state} />
        </div>
      </div>
      <Divider style={{ marginBottom: 12, marginTop: 12 }} />
      <div className={cx('content')}>
        <div className={cx('line')}>服务时间：{serviceTime(record.createTime) ?? '-'}</div>
        <div className={cx('line')}>服务时长：{handleServiceDuration(record.serviceDuration)}</div>
        {/* 人工方案隐藏评分 */}
        {record.taskType === 'Massage' && (
          <div className={cx('score-line')}>
            <span style={{ marginRight: 6 }}>手法评分</span>
            <ScoreStar score={record.robotTechScore} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ServiceRecordCard;
